var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-2 flex"},[_c('span',[_vm._v(_vm._s(_vm.question.num)+". ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.question.content.richText)}})]),_c('div',[_c('vote-search-content',{attrs:{"question":_vm.question}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }